/**
 * Get the value of a cookie by name.
 * Returns the value decoded with decodeURIComponent, or raw value on decode failure.
 * Returns null if the cookie is not found.
 */
export function getCookie(name: string): string | null {
  if (typeof document === 'undefined' || !document.cookie) {
    return null;
  }
  const nameEq = `${name}=`;
  const parts = document.cookie.split(';');
  for (const part of parts) {
    const trimmed = part.trim();
    if (trimmed.startsWith(nameEq)) {
      const value = trimmed.slice(nameEq.length).trim();
      try {
        return decodeURIComponent(value);
      } catch {
        return value;
      }
    }
  }
  return null;
}

/**
 * Returns true if a cookie with the given name exists (including empty value).
 * Used to distinguish "cookie absent" from "cookie present but empty".
 */
export function hasCookie(name: string): boolean {
  if (typeof document === 'undefined' || !document.cookie) {
    return false;
  }
  const nameEq = `${name}=`;
  const parts = document.cookie.split(';');
  for (const part of parts) {
    if (part.trim().startsWith(nameEq)) {
      return true;
    }
  }
  return false;
}
